import { Action } from '@ngrx/store';
import { Location } from '../location/location.model';

export enum LocationWsActionTypes {
  LocalCreateLocationSuccessWs = '[Location WS] Local Create Locations Success',
  LocalCreateLocationFailureWs = '[Location WS] Local Create Locations Failure',
  LocalUpdateLocationSuccessWs = '[Location WS] Local Update Locations Success',
  LocalUpdateLocationFailureWs = '[Location WS] Local Update Locations Failure',
  LocalRemoveLocationSuccessWs = '[Location WS] Local Remove Locations Success',
  LocalRemoveLocationFailureWs = '[Location WS] Local Remove Locations Failure',
  GlobalCreateLocationSuccessWs = '[Location WS] Global Create Locations Success',
  GlobalUpdateLocationSuccessWs = '[Location WS] Global Update Locations Success',
  GlobalRemoveLocationSuccessWs = '[Location WS] Global Remove Locations Success',
  GlobalUpdateLocationStatusSuccessWs = '[Location WS] Global Update Location Status Success',
}

export class LocalCreateLocationSuccessWs implements Action {
  readonly type = LocationWsActionTypes.LocalCreateLocationSuccessWs;

  constructor(public payload: { id: string; correlation_id: string }) {}
}

export class LocalCreateLocationFailureWs implements Action {
  readonly type = LocationWsActionTypes.LocalCreateLocationFailureWs;

  constructor(public payload: { correlation_id: string; message: string }) {}
}

export class LocalUpdateLocationSuccessWs implements Action {
  readonly type = LocationWsActionTypes.LocalUpdateLocationSuccessWs;

  constructor(public payload: { id: string; correlation_id: string }) {}
}

export class LocalUpdateLocationFailureWs implements Action {
  readonly type = LocationWsActionTypes.LocalUpdateLocationFailureWs;

  constructor(public payload: { correlation_id: string; message: string }) {}
}

export class LocalRemoveLocationSuccessWs implements Action {
  readonly type = LocationWsActionTypes.LocalRemoveLocationSuccessWs;

  constructor(public payload: { correlation_id: string }) {}
}

export class LocalRemoveLocationFailureWs implements Action {
  readonly type = LocationWsActionTypes.LocalRemoveLocationFailureWs;

  constructor(public payload: { correlation_id: string; message: string }) {}
}

export class GlobalCreateLocationSuccessWs implements Action {
  readonly type = LocationWsActionTypes.GlobalCreateLocationSuccessWs;
  constructor(public payload: Location) {}
}

export class GlobalUpdateLocationSuccessWs implements Action {
  readonly type = LocationWsActionTypes.GlobalUpdateLocationSuccessWs;
  constructor(public payload: Location) {}
}

export class GlobalRemoveLocationSuccessWs implements Action {
  readonly type = LocationWsActionTypes.GlobalRemoveLocationSuccessWs;
  constructor(public payload: Location['id']) {}
}

export class GlobalUpdateLocationStatusSuccessWs implements Action {
  readonly type = LocationWsActionTypes.GlobalUpdateLocationStatusSuccessWs;

  constructor(
    public payload: {
      location: { location_status_id: number; id: number; correlation_id: string };
    }
  ) {}
}

export type LocationWsActions =
  | LocalCreateLocationSuccessWs
  | LocalCreateLocationFailureWs
  | LocalUpdateLocationSuccessWs
  | LocalUpdateLocationFailureWs
  | LocalRemoveLocationSuccessWs
  | LocalRemoveLocationFailureWs
  | GlobalCreateLocationSuccessWs
  | GlobalUpdateLocationSuccessWs
  | GlobalRemoveLocationSuccessWs
  | GlobalUpdateLocationStatusSuccessWs;
